/*
 * Copyright (c) 2024, King Living
 * Regional postcode / postal / ZIP patterns (user input may include spaces).
 * Reference: King Living FSD - Field Validation (Atlassian).
 */

/** @type {Record<string, RegExp>} */
export const POSTAL_PATTERNS = {
  AU: /^\d{4}$/,
  NZ: /^\d{4}$/,
  SG: /^\d{6}$/,
  MY: /^\d{5}$/,
  CA: /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/i,
  US: /^\d{5}(-\d{4})?$/,
  UK: /^[A-Z]{1,2}\d[A-Z\d]?\s?\d[A-Z]{2}$/i,
  GB: /^[A-Z]{1,2}\d[A-Z\d]?\s?\d[A-Z]{2}$/i,
};

/**
 * @param {string} value
 * @returns {string}
 */
export function normalizePostcodeForValidation(value) {
  if (!value || typeof value !== 'string') {
    return '';
  }

  return value.trim().toUpperCase();
}

/**
 * @param {string} countryCode
 * @returns {RegExp|undefined}
 */
export function getPostalPattern(countryCode) {
  const code = (countryCode || '').toUpperCase();

  return POSTAL_PATTERNS[code] || POSTAL_PATTERNS.AU;
}
